import GridView from "../../components/controls/GridView/GridView";
import accountService, {
  Account,
  AccountCacheService,
  AccountDto,
  GetAccountQuery,
} from "../../services/accountService";
import { useNavigate } from "react-router-dom";
import cls from "./account-listing.module.css";
import { MenuItem } from "../../models/menu";
import { useEffect, useState } from "react";
import TransactionLimit from "../../components/controls/TransactionLimit/TransactionLimit";
import FormModal from "../../components/controls/FormModal/FormModal";
import { AccountTransactionLimit } from "../../models/interfaces";
import FindRecord from "../../components/controls/FindRecord/FindRecord";
import customerService, { Customer } from "../../services/customerService";
import TextBox from "../../components/controls/TextBox/TextBox";
import ComboBox from "../../components/controls/ComboBox/ComboBox";
import FormCommand from "../../components/controls/FormCommand/FormCommand";
import Frame from "../../components/controls/Frame/Frame";
import CheckBox from "../../components/controls/Checkbox/CheckBox";

export type AccountListingPageProps = {
  displayAddButton?: boolean;
  displayContextMenu?: boolean;
  onAccountSelected?: (account: AccountDto) => void;
  displayPageTitle?: boolean;
  onCloseAccountListingPage?: () => void;
  isModal?: boolean;
};

export function useAccounts(query: GetAccountQuery) {
  const [accounts, setAccounts] = useState<AccountDto[]>([]);
  const [searchQuery, setSearchQuery] = useState(query);

  const getAccounts = async () => {
    var res = await accountService.getAccounts(query);

    if (res?.status && res.data) {
      setAccounts([...res.data!]);
      //Something happen
    }
  };

  const setSearchQueryCriteria = (s: string) =>
    setSearchQuery({ ...query, query: s });

  const setSearchPageIndex = (index: number) =>
    setSearchQuery({ ...query, pageIndex: index });

  const setSearchPageSize = (index: number) =>
    setSearchQuery({ ...query, pageSize: index });

  useEffect(() => {
    debugger;
    getAccounts();
  }, [query]);

  return {
    accounts,
    setSearchQueryCriteria,
    setSearchPageIndex,
    setSearchPageSize,
  };
}

export const AccountListingPage = (props: AccountListingPageProps) => {
  const navigator = useNavigate();
  const [showTransactionLimit, setShowTransactionLimit] = useState(false);
  const [account, setAccount] = useState<AccountDto>();
  const [accounts, setAccounts] = useState<AccountDto[]>([]);
  const [pageIndex, setPageIndex] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const accountdata = useAccounts({});

  console.log(accountdata.accounts);

  const createOrUpdateAccount = async () => {
    if (account !== undefined) {
      const resp = await accountService.createOrUpdateAccount(
        account,
        Number(account?.id)
      );
      if (resp.status === true) {
        alert("Account saved successfully");
        setAccount(undefined); //will also hide the modal
      }
    }
  };

  function getAccountContextMenu(): MenuItem<AccountDto>[] {
    const accountMenu: MenuItem<AccountDto>[] = [
      new MenuItem("Configure Transaction Limit", (e: AccountDto) => {
        setShowTransactionLimit(!showTransactionLimit);
        setAccount(e);
      }),
      new MenuItem("Delete Account", (e: AccountDto) => {
        const deleteAccount = async () => {
          const resp = await accountService.deleteAccount(e.id ?? 0);
          if (resp.status) {
            alert(resp.message);

            setAccounts(accounts.filter((d) => d.id !== e.id));
          }
        };

        const ans = window.confirm(
          "Are you sure you want to delete this account?"
        );
        if (ans) {
          deleteAccount();
        }
      }),
      new MenuItem("Edit Account", (e: AccountDto) => {
        setAccount(e);
      }),
    ];

    return accountMenu;
  }

  return (
    <div className="row">
      <div className="col">
        <Frame>
          <div>
            <h3>Accounts</h3>

            <GridView<AccountDto>
              context={"account"}
              showSearchBar={true}
              showAddButton={true}
              onAddRecord={() => setAccount({})}
            >
              <GridView.Header>
                <thead>
                  <tr>
                    <th>AccountNo</th>
                    <th>Account Name</th>
                    <th>Account Type</th>
                    <th>Account Group</th>
                    <th></th>
                  </tr>
                </thead>
              </GridView.Header>
              <GridView.Content>
                {accounts.map((d) => {
                  return (
                    <tr>
                      <th>{d.accountNo}</th>
                      <th>{d.name}</th>
                      <th>{d.accountTypeName} </th>
                      <th>{d.accountGroupName}</th>
                      <th></th>
                    </tr>
                  );
                })}
              </GridView.Content>
            </GridView>

            {showTransactionLimit && (
              <FormModal
                onClose={() => setShowTransactionLimit(!showTransactionLimit)}
              >
                <TransactionLimit<AccountTransactionLimit>
                  displayTitle={() => (
                    <h4>{account?.accountNo + " - " + account?.name}</h4>
                  )}
                  hideColumns={["accountId", "id"]}
                  onGetTransactionLimits={async () => {
                    return accountService.getTransactionLimits(
                      account?.id ?? 0
                    );
                  }}
                  onDeleteLimit={async (limit, limits) => {
                    const resp = await accountService.removeTransactionLimit(
                      account?.id ?? 0,
                      limit.id.toString()
                    );
                    if (resp.status) {
                      return limits.filter((d) => d.id !== limit.id);
                    }
                  }}
                  onSaveChanges={async (limit) => {
                    const resp = await accountService.setTransactionLimit(
                      account?.id ?? 0,
                      {
                        amount: limit.amount,
                        period: limit.period,
                        transactionType: limit.transactionType,
                      }
                    );

                    if (resp.status) {
                      return resp.data;
                    }
                  }}
                />
              </FormModal>
            )}

            {account && (
              <FormModal onClose={() => setAccount(undefined)}>
                <AccountOpeningForm
                  account={account}
                  onSetAccount={setAccount}
                  onSave={createOrUpdateAccount}
                ></AccountOpeningForm>
              </FormModal>
            )}
          </div>
        </Frame>
      </div>
    </div>
  );
};

export type AccountOpeningFormProps = {
  displayHeader?: boolean;
  account?: AccountDto;
  onSetAccount?: (account: AccountDto) => void;
  onSave: (account: AccountDto) => Promise<void>;
  customer?: Customer;
};

export function AccountOpeningForm(props: AccountOpeningFormProps) {
  const [account, setAccount] = useState<AccountDto | undefined>(
    props.account ?? undefined
  );
  const accountCacheService = new AccountCacheService();

  return (
    <div className="row">
      <div className="col">
        <Frame>
          <div>
            <div className="row">
              <div className="col">
                <form>
                  <div className="form-group">
                    <label htmlFor="accountName" className="control-label">
                      Account Name
                    </label>
                    <input
                      required
                      type="text"
                      name="accountName"
                      id="accountName"
                      className="form-control form-control-sm"
                      value={props?.account?.name}
                      onChange={(e) =>
                        props?.onSetAccount?.({
                          ...props.account,
                          name: e.currentTarget.value,
                        })
                      }
                    />
                  </div>

                  <div className="row">
                    <div className="col">
                      <div className="form-group">
                        <label
                          htmlFor="accountTypeId"
                          className="control-label"
                        >
                          Account Type
                        </label>
                        <select
                          required
                          name="accountType"
                          id="accountTypeId"
                          className="form-control form-control-sm"
                          value={props?.account?.accountTypeId}
                          onChange={(e) =>
                            props?.onSetAccount?.({
                              ...props.account,
                              accountTypeId: Number(e.currentTarget.value),
                            })
                          }
                        >
                          <option value={0}>Select account type</option>
                          {accountCacheService.getAccountTypes().map((d) => {
                            return (
                              <option key={d.id} value={d.id}>
                                {d.name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>
                    <div className="col">
                      <div className="form-group">
                        <label
                          htmlFor="accountGroupId"
                          className="control-label"
                        >
                          Account Group
                        </label>
                        <select
                          required
                          name="accountGroup"
                          id="accountGroupId"
                          className="form-control form-control-sm"
                          title="accountGroup"
                          value={props?.account?.accountGroupId}
                          onChange={(e) =>
                            props?.onSetAccount?.({
                              ...props.account,
                              accountGroupId: Number(e.currentTarget.value),
                            })
                          }
                        >
                          <option value={0}>Select account group</option>
                          {accountCacheService.getAccountGroups().map((d) => {
                            return (
                              <option key={d.id} value={d.id}>
                                {d.name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col">
                      <FindRecord<Customer>
                        text="Select Customer"
                        id="selectCustomer"
                        onSelectRecord={(record) => {
                          return record?.customerName ?? "";
                        }}
                        getRecords={() => {
                          const resp = customerService.getCustomers({});
                          return resp;
                        }}
                        hideColumns={[
                          "uid",
                          "dateOfBirth",
                          "customerTypeId",
                          "creditCode",
                          "Gender",
                          "otherName",
                          "firstname",
                          "lastName",
                          "nationality",
                          "maritalStatusId",
                          "religionId",
                          "IdplaceofIssuance",
                          "fullName",
                          "businessId",
                          "locationId",
                          "signatureFile",
                          "photoFile",
                        ]}
                      />
                    </div>
                    <div className="col">
                      <div className="form-group">
                        <label htmlFor="currency" className="control-label">
                          Currency
                        </label>
                        <select
                          required
                          name="currency"
                          id="currency"
                          className="form-control"
                          onChange={(e) =>
                            props?.onSetAccount?.({
                              ...props.account,
                              currencyId: Number(e.currentTarget.value),
                            })
                          }
                          value={props?.account?.currencyId}
                        >
                          <option value={""}>Select Currency</option>
                          {accountCacheService.getCurrencies().map((d) => {
                            return (
                              <option key={d.id} value={d.id}>
                                {d.name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col">
                      <CheckBox
                        id="enableSMSAlert"
                        text="Enable SMS Alert"
                        onChecked={(value) => {
                          props?.onSetAccount?.({
                            ...props.account,
                            enableSMSAlert: value,
                          });
                        }}
                        checked={props?.account?.enableSMSAlert}
                      />

                      <TextBox
                        id="phoneNo"
                        placeHolder="Enter PhoneNo"
                        text=""
                        value={props?.account?.smsAlertPhoneNo}
                        onChange={(e) =>
                          props?.onSetAccount?.({
                            ...props.account,
                            smsAlertPhoneNo: e.currentTarget.value,
                          })
                        }
                      />
                    </div>
                    <div className="col">
                      <CheckBox
                        id="enableEmailAlert"
                        text="Enable Email Alert"
                        checked={props?.account?.enableSMSAlert}
                        onChecked={(value) => {
                          props?.onSetAccount?.({
                            ...props.account,
                            enableEmailAlert: value,
                          });
                        }}
                      />

                      <TextBox
                        id="email"
                        placeHolder="Enter Email"
                        text=""
                        value={props?.account?.emailAlertAddress}
                        onChange={(e) =>
                          props?.onSetAccount?.({
                            ...props.account,
                            emailAlertAddress: e.currentTarget.value,
                          })
                        }
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col">
                      <ComboBox
                        id="accountMarketer"
                        text="Account Marketer"
                        prompt="Select Marketer"
                        value={props?.account?.marketerId}
                        onChange={(e) =>
                          props?.onSetAccount?.({
                            ...props.account,
                            marketerId: Number(e.currentTarget.value),
                          })
                        }
                        items={accountCacheService.getAccountMarketers()}
                      />
                    </div>
                    <div className="col">
                      <ComboBox
                        id="accountOfficer"
                        text="Account Officer"
                        prompt="Select Officer"
                        value={props?.account?.officerId}
                        onChange={(e) =>
                          props?.onSetAccount?.({
                            ...props.account,
                            officerId: Number(e.currentTarget.value),
                          })
                        }
                        items={accountCacheService.getAccountOfficers()}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <CheckBox
                      id="enableDebitBalance"
                      text="Enable Debit Balance(s)"
                      checked={props?.account?.allowDebitBalance}
                      onChecked={(value) => {
                        props?.onSetAccount?.({
                          ...props.account,
                          allowDebitBalance: value,
                        });
                      }}
                    />
                  </div>

                  <ComboBox
                    id="location"
                    text="Location (Branch)"
                    prompt="Select Branch / Location"
                    value={props?.account?.locationId}
                    onChange={(e) =>
                      props?.onSetAccount?.({
                        ...props.account,
                        locationId: Number(e.currentTarget.value),
                      })
                    }
                  />

                  <FormCommand onSubmit={() => props?.onSave} />
                </form>
              </div>
            </div>
          </div>
        </Frame>
      </div>
    </div>
  );
}
